import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Booking, Listing } from '@clooper/core';
import { faClock, faEllipsisHAlt, faEye, faMapMarkerAlt, faPhone, faUsers } from '@fortawesome/pro-light-svg-icons';
import moment from 'moment';

@Component({
  selector: 'app-corporate-map-popup',
  templateUrl: './corporate-map-popup.component.html',
  styleUrls: ['./corporate-map-popup.component.scss']
})
export class CorporateMapPopupComponent implements OnInit {

  totalDuration: number = 0
  icons = {
    map: faMapMarkerAlt,
    eye: faEye,
    elipse: faEllipsisHAlt,
    clock: faClock,
    people: faUsers,
    phone: faPhone
  }
  occupants = ''

  @Input() listing: Listing | null
  @Input() booking: Booking
  @Input() employee: any | null
  @Output() closePopup: EventEmitter<any> = new EventEmitter();



  constructor(
  ) { }

  ngOnInit(): void {
    const checkIn = new Date(this.booking.check_in).getTime();
    const checkOut = new Date(this.booking.check_out).getTime();
    const diff = checkOut - checkIn
    this.totalDuration = moment.duration(diff, 'milliseconds').asDays()
    this.constructString()
  }


  constructString() {
    let string = `${+this.booking.guests['adults'] ? this.booking.guests['adults'] + (this.booking.guests['adults'] > 1 ? " Adults," : " Adult,") : ''} ${+this.booking.guests['children'] ? this.booking.guests['children'] + (this.booking.guests['children'] > 1 ? " Children," : " Child,") : ''}  ${+this.booking.guests['infants'] ? this.booking.guests['infants'] + (this.booking.guests['infants'] > 1 ? " Infants," : " Infant,") : ''} ${+this.booking.guests['pets'] ? this.booking.guests['pets'] + (this.booking.guests['pets'] > 1 ? " Pets," : " Pet,") : ''}`
    string = string.trim()
    if (string.charAt(string.length - 1) === ',') {
      let temp = string.split('')
      temp.splice(string.length - 1)
      string = temp.join("")
    }
    this.occupants = string
  }

}
